import {Component, Input, OnInit} from '@angular/core';
import {EventItem, Lookups} from "@model";

@Component({
  selector: 'app-event-info-tab',
  templateUrl: './event-info-tab.component.html',
  styleUrls: ['./event-info-tab.component.scss']
})
export class EventInfoTabComponent implements OnInit {


  @Input() currentEventItem: EventItem | undefined;
  mediaVideoHor: string | undefined;
  mediaVideoVert: string | undefined;
  @Input({required: true}) languages: Lookups[] = [];

  ngOnInit(): void {
    this.makeLinksEmbeddable();
  }

  makeLinksEmbeddable() {
    if (this.makeLinkEmbeddable(this.currentEventItem?.mediaContentVideoHor)) {
      this.mediaVideoHor = 'https://www.youtube.com/embed/' + this.makeLinkEmbeddable(this.currentEventItem?.mediaContentVideoHor);
      this.videoHorLinkIsValid();
    }
    if (this.makeLinkEmbeddable(this.currentEventItem?.mediaContentVideoVert)) {
      this.mediaVideoVert = 'https://www.youtube.com/embed/' + this.makeLinkEmbeddable(this.currentEventItem?.mediaContentVideoVert);
      this.videoVertLinkIsValid();
    }
  }

  getLabel() {
    return true;
  }

  makeLinkEmbeddable(link: string | undefined): string | undefined {
    const regex1: RegExp = /[?&]v=([^&#]*)/;
    const regex2: RegExp = /\/shorts\/([^\/?]+)/;
    const match1: RegExpMatchArray | null | undefined = link?.match(regex1);
    const match2: RegExpMatchArray | null | undefined = link?.match(regex2);
    if (match1) {
      return match1 ? match1[1] : undefined;
    }
    if (match2) {
      return match2 ? match2[1] : undefined;
    }
    return undefined;
  }

  videoHorLinkIsValid(): boolean {
    var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return !!this.mediaVideoHor?.match(p);
  }

  videoVertLinkIsValid(): boolean {
    var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return !!this.mediaVideoVert?.match(p);
  }
}
